// This is not needed as hook, but getting ahead of eventually moving it to async load for cleaner version
export const useCustomConfig = () => {
    const customConfig = window ? window.__NOSTO_CUSTOM_CONFIG__ || {} : {}
    return { customConfig };
}